import { Link } from "react-router-dom";
import { PETITION_URL, IMAGES } from "@/lib/content";
import { Wordmark } from "@/components/Header";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-gooi-anthracite text-gooi-offwhite">
    <div
      data-testid="footer-photo-strip"
      aria-hidden="true"
      className="relative h-36 overflow-hidden md:h-52"
    >
      <div className="grid h-full grid-cols-3 gap-1">
        {[IMAGES.hero, IMAGES.nature, IMAGES.asphalt].map((src, i) => (
          <img key={i} src={src} alt="" loading="lazy" className="duotone-photo h-full w-full object-cover" />
        ))}
      </div>
      <div className="absolute inset-0 bg-gooi-anthracite/60" />
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-gooi-anthracite" />
    </div>
    <div className="mx-auto max-w-[90rem] px-5 py-20 md:px-12 md:py-28">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-6">
          <Wordmark dark />
          <p className="mt-4 font-display text-2xl font-medium tracking-tight text-gooi-offwhite/90 md:text-3xl">
            Samen voor 80 km/u
          </p>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-gooi-offwhite/60">
            1 minuut langer rijden. Iedere dag meer rust.
          </p>
        </div>
        <nav className="md:col-span-3" aria-label="Footer navigatie">
          <p className="text-xs uppercase tracking-[0.25em] text-gooi-offwhite/50">Actie</p>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a
                href={PETITION_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-petition-link"
                className="font-semibold text-gooi-offwhite transition-colors duration-300 hover:text-white"
              >
                Petitie op petities.nl
              </a>
            </li>
            <li>
              <a href="/#bronnen" data-testid="footer-sources-link" className="text-gooi-offwhite/70 transition-colors duration-300 hover:text-gooi-offwhite">
                Bronnen
              </a>
            </li>
            <li>
              <a href="/#contact" data-testid="footer-contact-link" className="text-gooi-offwhite/70 transition-colors duration-300 hover:text-gooi-offwhite">
                Contact
              </a>
            </li>
            <li>
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-gooi-offwhite/70 transition-colors duration-300 hover:text-gooi-offwhite">
                Privacy
              </Link>
            </li>
          </ul>
        </nav>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.25em] text-gooi-offwhite/50">Het traject</p>
          <p className="mt-4 text-sm leading-relaxed text-gooi-offwhite/70">
            A1 tussen aansluiting Naarden/Bussum en knooppunt Eemnes, in beide rijrichtingen. Circa 7 kilometer.
          </p>
        </div>
      </div>
      <div className="mt-16 border-t border-gooi-offwhite/10 pt-8">
        <p className="max-w-3xl text-xs leading-relaxed text-gooi-offwhite/50">
          Rust langs de A1 is een onafhankelijk burgerinitiatief. Genoemde effecten zijn gebaseerd op openbare
          onderzoeken en indicatieve berekeningen. Werkelijke effecten kunnen per locatie en verkeerssituatie
          verschillen.
        </p>
        <p className="mt-4 text-xs text-gooi-offwhite/40">© {new Date().getFullYear()} Rust langs de A1</p>
      </div>
    </div>
  </footer>
);
